var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"c-nav",class:{ 'c-nav--light': _vm.isStoryLightMode },attrs:{"itemscope":"","itemtype":"http://schema.org/SiteNavigationElement"}},[_c('navigation-main'),_c('neighbourhood-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }